const { shouldShowRemoveFamilyConfirmationDialog, showRemoveFamilyConfirmationDialog } = require('../../components/dialogs/RemoveFamilyConfirmationDialog.ts');
const { handleFirstMileFontActivationSuccess, handleFirstMileFontActivation } = require('../../components/dialogs/FontActivationFirstMileDialog.ts');

/**
 * A service for displaying first mile dialog's for various use cases.
 *
 * @ngInject
 * @deprecated
 */
function FirstMileService(DialogService, UserPrefsService) {
  return {
    shouldShowFontActivationDialog: shouldShowFontActivationDialog,
    showFontActivationDialog: showFontActivationDialog,
    shouldShowRemoveFamilyConfirmationDialog: shouldShowRemoveFamilyConfirmationDialog,
    showRemoveFamilyConfirmationDialog: showRemoveFamilyConfirmationDialog,
    onUseModelFontActivation: onUseModelFontActivation,
    onUseModelFontActivationSuccess: onUseModelFontActivationSuccess
  };

  /**
   * Should the user see the font activation modal?
   * @return {Promise}
   */
  function shouldShowFontActivationDialog() {
    return UserPrefsService.getUserPrefs().then(function(userPrefs) {
      return !userPrefs.hideFontActivationModal;
    });
  }

  /**
   * Shows the dialog that the user sees after activating a font.
   */
  function showFontActivationDialog() {
    DialogService.show('/angular_templates/dialogs/font_activation_first_mile.html').then(function(dialog) {
      dialog.handleOKButton = function() {
        if (dialog.optOutOfModal) {
          UserPrefsService.updatePrefs({ hideFontActivationModal: true });
        }
        DialogService.close();
      };
    });
  }

  function onUseModelFontActivation(opts = {}) {
    handleFirstMileFontActivation(opts);
  }

  function onUseModelFontActivationSuccess(opts = {}) {

    handleFirstMileFontActivationSuccess(opts);
  }
}

module.exports = FirstMileService;
